import { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Image, Modal, Row } from "react-bootstrap";
import { voucher_list, voucher_sell } from "./fetch";
import { formatNumberWithout } from "../../helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
const Voucher = () => {
  const [listVoucher, setListVoucher] = useState([]);
  const [showDetailCheckOut, setShowDetailCheckout] = useState(false);
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);

  const handleGetVoucher = useCallback(async () => {
    try {
      const res = await voucher_list();
      if (res?.status) {
        setListVoucher(res?.data);
      }
    } catch (error) {}
  }, []);

  function handleIncrement(id) {
    setListVoucher((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          const currentQty = item.qty || 0;
          if (currentQty >= 20) return item; // batas maksimal 20
          return { ...item, qty: currentQty + 1 };
        }
        return item;
      })
    );
  }

  function handleDecrement(id) {
    setListVoucher((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          const currentQty = item.qty || 0;
          const newQty = currentQty - 1;
          if (newQty <= 0) {
            const { qty, ...rest } = item;
            return rest; // hapus qty
          }
          return { ...item, qty: newQty };
        }
        return item;
      })
    );
  }

  const calculateTotals = () => {
    let totalPrice = 0;
    let totalQty = 0;

    listVoucher.forEach((p) => {
      const price = JSON.parse(p?.variation || "[]")?.[0]?.price || 0;
      const qty = p?.qty || 0;

      totalPrice += price * qty;
      totalQty += qty;
    });

    return { totalPrice, totalQty };
  };

  const handleSellVoucher = () => {
    try {
      listVoucher
        ?.filter((ps) => ps?.qty !== undefined)
        ?.map(async (p) => {
          const params = {
            variation: p?.variation,
            quantity: p?.qty,
          };
          const res = await voucher_sell(params);
          if (res.status) {
            console.log(res?.data);
          }
        });

      handleGetVoucher();
      return setShowModalConfirmation(false);
    } catch (error) {}
  };

  useEffect(() => {
    handleGetVoucher();
  }, [handleGetVoucher]);
  return (
    <Container className="home p-0" fluid>
      <Modal show={showModalConfirmation} centered>
        <Modal.Body>
          <Col className="mb-3">Konfirmasi Pesanan?</Col>
          <Col className="d-flex align-items-center justify-content-between">
            <Button
              style={{ width: "48%" }}
              variant="success"
              onClick={() => handleSellVoucher()}
            >
              Setuju
            </Button>
            <Button
              style={{ width: "48%" }}
              variant="danger"
              onClick={() => setShowModalConfirmation(false)}
            >
              Batal
            </Button>
          </Col>
        </Modal.Body>
      </Modal>
      <div className="p-3">
        <Col className="text-center">
          <Image
            src={require("../../assets/voucher-partner.png")}
            className="w-50 mb-4"
          />
        </Col>
        {listVoucher?.map((p, i) => {
          return (
            <Col className="box-voucher mb-3" key={i}>
              <Col className="d-flex mb-2">
                <Image
                  src={`${process.env.REACT_APP_API_URL_IMAGE}${p?.event_content?.thumbnail}`}
                  className="w-25 me-3"
                  style={{ borderRadius: "10px" }}
                />
                <Col>
                  <h5 className="fw-bold">
                    {p?.event_content?.information?.title}
                  </h5>
                  <h6 className="fw-bold">
                    {JSON.parse(p?.variation)?.[0]?.name}
                  </h6>
                  <Col className="d-flex align-items-center justify-content-between">
                    <h6>
                      Tersedia
                      <br />
                      {p?.total} Voucher
                    </h6>
                    <h6 className="text-end">
                      Harga
                      <br />
                      Rp
                      {formatNumberWithout(
                        String(JSON.parse(p?.variation)?.[0]?.price)
                      )}
                    </h6>
                  </Col>
                </Col>
              </Col>
              {p?.qty >= 1 ? (
                <Col className="d-flex align-items-center justify-content-between">
                  <Col
                    xs={3}
                    className="bg-ticket-tot"
                    onClick={() => handleDecrement(p?.id)}
                  >
                    <FontAwesomeIcon icon={faMinus} />
                  </Col>
                  <Col
                    xs={3}
                    className="bg-ticket-txtot justify-content-end align-items-end d-flex-col"
                  >
                    <h4 className="bg-ticket-txtot">{p?.qty || 0}</h4>
                  </Col>
                  <Col
                    xs={3}
                    className="bg-ticket-tot"
                    onClick={() => handleIncrement(p?.id)}
                    style={{ zIndex: 999 }}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </Col>
                </Col>
              ) : (
                <Button
                  onClick={() => handleIncrement(p?.id)}
                  style={{
                    backgroundColor: "var(--primary-color)",
                    border: "1px solid var(--primary-color)",
                  }}
                  className="w-100"
                >
                  Jual Voucher
                </Button>
              )}
            </Col>
          );
        })}
      </div>
      {calculateTotals()?.totalQty !== 0 && (
        <Col className="checkout-box">
          <Col
            className="d-flex align-items-center justify-content-between mt-3 mb-2"
            onClick={() => setShowDetailCheckout(!showDetailCheckOut)}
          >
            <h6 className="fw-bold">Detail Pesanan</h6>
            <u style={{ color: "var(--primary-color)" }}>
              {!showDetailCheckOut ? (
                <h6 style={{ color: "var(--primary-color)" }}>Lihat Detail</h6>
              ) : (
                <h6 style={{ color: "var(--primary-color)" }}>Tutup Detail</h6>
              )}
            </u>
          </Col>
          {showDetailCheckOut && (
            <Col className="mb-3">
              {listVoucher
                .filter((p) => p?.qty !== undefined)
                .map((p, index) => {
                  return (
                    <Row key={index} className="mb-2">
                      <Col xs={8} className="text-start">
                        {JSON.parse(p?.variation)?.[0]?.name} ({p?.qty}x)
                      </Col>
                      <Col xs={4} className="text-end">
                        {formatNumberWithout(
                          String(
                            p?.qty * JSON.parse(p?.variation)?.[0]?.price || 0
                          )
                        )}
                      </Col>
                    </Row>
                  );
                })}
            </Col>
          )}
          <Col className="d-flex align-items-center justify-content-between mb-2">
            <h6>
              Total ({formatNumberWithout(calculateTotals()?.totalQty || 0)}x)
            </h6>
            <h6>Rp{formatNumberWithout(calculateTotals()?.totalPrice || 0)}</h6>
          </Col>
          <Button
            className="w-100 mb-2"
            style={{
              backgroundColor: "var(--primary-color)",
              border: "1px solid var(--primary-color)",
            }}
            onClick={() => setShowModalConfirmation(true)}
          >
            Lanjutkan Pesanan
          </Button>
        </Col>
      )}
    </Container>
  );
};

export default Voucher;
